'use client'

import Image from 'next/image'
import Link from 'next/link'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { Media, Tag } from '@/payload-types'

export default function CategoriesSlider({ tags }: { tags: Tag[] }) {
	return (
		<div className="w-full lg:w-3/5">
			{/* Mobile: Swiper */}
			<div className="lg:hidden">
				<Swiper
					modules={[Pagination]}
					spaceBetween={8}
					slidesPerView={1.2}
					pagination={{ clickable: true }}
					className="categories-swiper"
					breakpoints={{
						640: {
							slidesPerView: 1.5,
							spaceBetween: 12,
						},
					}}
				>
					{tags.map((tag: Tag, index) => (
						<SwiperSlide key={index}>
							<Link href={`/list?tag=${tag?.slug}`} className="flex items-end justify-between rounded-2xl h-[210px] bg-grey-400 text-white px-4 py-5 relative overflow-hidden group w-full">
								<div className="absolute inset-0 bg-center bg-no-repeat bg-cover transition-transform duration-300 ease-in-out group-hover:scale-110" style={{ backgroundImage: `url(${(tag.image as Media)?.s3Url})` }}></div>
								<div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-black/80 via-black/50 to-transparent"></div>
								<span className="text-lg font-alt font-medium relative z-10">{tag?.name}</span>
							</Link>
						</SwiperSlide>
					))}
				</Swiper>
			</div>

			{/* Desktop: Flex layout */}
			<div className="hidden lg:flex gap-5 items-stretch">
				{tags.map((tag: Tag, index) => (
					<Link href={`/list?tag=${tag?.slug}`} key={index} className="flex-1 flex items-end justify-between rounded-2xl h-[380px] bg-grey-400 text-white px-4 py-12 relative overflow-hidden group">
						<div className="absolute inset-0 bg-center bg-no-repeat bg-cover transition-transform duration-300 ease-in-out group-hover:scale-110" style={{ backgroundImage: `url(${(tag.image as Media)?.s3Url})` }}></div>
						<div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
						<span className="text-lg font-alt font-medium relative z-10">{tag?.name}</span>
						<Image className='relative z-10' src={'https://res.cloudinary.com/dr04tcjag/image/upload/v1741485264/arrow-up-right_xqooaz.png'} alt={tag?.name} width={20} height={20} />
					</Link>
				))}
			</div>
		</div>
	)
}

